module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f83649a6f99757d24102449927a44929.png";